<template>
	<div class="data-block" v-if="groups.length && dates.length">
    <div class='data-block-top'> 
      <h3>{{ title }}</h3>
      <div class="top-right-item">
        <img src="@/assets/img/download.svg" alt="">
        <a class="top-button" @click="downloadAnalytics" test-id="download_report">Скачать</a>
      </div>
    </div>
		<AnalyticsFilter
			:dates="dates" 
			:groups="groupNames"
      :portfolioView="portfolioView"
      :withCohorts="withCohorts"
      :dateGroupingAvaliable="analytics[0]?.date_grouping_avaliable"
			@onGroupChange="onGroupChange" 
			@onDateChange="onDateChange"
      @onDataGroupingChange="onDataGroupingChange"
      @onSubmitClick="onSubmitClick"
		/>
		<template v-if="analytics.length > 0">
			<AnalyticsTable 
        :analytics="table" 
        :portfolioView="portfolioView" 
        v-for="(table, key) in analytics"
        :key="key" 
        :multiTitles='multiTitles' 
        :showAdditionalData="grouping != ''" 
        :dates="dates"
        :additionalDataType="grouping"
        @onDateFilterChange="onDateFilterChange"
      />	
		</template>
		<template v-else>
			<h5>Данных нет</h5>
		</template>
	</div>
  <div class="data-block" v-else>
    <h5>Недостаточно данных ({{ title }}) {{dates}}</h5>
  </div>
  <div class="loading" v-show="loading">
    <img src="@/assets/img/loading.svg" alt="" srcset="">
  </div>
</template>

<script>
import AnalyticsTable from "@/components/Analytics/AnalyticsTable";
import AnalyticsFilter from "@/components/Analytics/AnalyticsFilter";

export default {
	name: 'AnalyticsDataBlock',
	components: {
    AnalyticsTable,
    AnalyticsFilter,
  },
  data() {
    return {
      analytics: [],
      activeReportDates: [],
      activeGroups: [],
      activeGroupName: [],
      grouping: '',
      loading: false,
      selectedAdvancedFilterDate: null,
    }
  },
  props: {
    title: String,
    link: String,
    dates: Array,
    groups: Array,
    multiTitles: Boolean, 
    portfolioView: {
      type: Boolean,
      default: false
    },
    withCohorts: {
      type: Boolean,
      default: false
    },
  },
  mounted(){
    if(this.groups.length > 0){
      this.activeGroups.push(this.groups[0].id)
      this.activeGroup = this.groups[0].id
      this.activeGroupName = this.groups[0].name
    }

    if(this.dates.length > 0){
      this.activeReportDates.push(Object.values(this.dates)[0])
    }

    this.selectedAdvancedFilterDate = Object.values(this.dates)[0]
    this.getAnalyticsData()
  },
  computed: {
    groupNames() {
      return this.groups.map(group => group.name)
    }
  },
  methods: {
    getAnalyticsData(){
      this.loading = true
      if (!this.portfolioView) {
        let requestlink = `${this.link}?forecast_date=${this.activeReportDates}&group=${this.activeGroup}`
        
        if(this.selectedAdvancedFilterDate){
          requestlink += `&dz_filter_date=${this.selectedAdvancedFilterDate}`
        }

        this.$http
          .get(requestlink)
          .then(response => {
            if(response.status === 200){
              this.analytics = response.data.data
            }else{
              this.analytics = []
            }
          })
          .catch(()=>{
            this.analytics = []
          })
          .finally(()=>{this.loading = false})
      } else {
        this.$http
          .get(`${this.link}?report_date=${this.activeReportDates}`)
          .then(response => {
            if(response.status === 200){
              this.analytics = response.data.data
            }else{
              this.analytics = []
            }
          })
          .finally(()=>{this.loading = false})
      }
    },
    onDateFilterChange(date){
      this.selectedAdvancedFilterDate = date
      this.getAnalyticsData()
    },
    onSubmitClick(){
      this.getAnalyticsData()
    },
    onGroupChange(data){
      this.activeGroup = this.groups.filter(group => data.includes(group.name)).map(group => group.id)
      this.activeGroupName = this.groups.filter(group => data.includes(group.name)).map(group => group.name)
    },
    onDateChange(data){
      this.activeReportDates = this.dates.filter(date => data.includes(date)).map(date => date)
    },
    onDataGroupingChange(data){
      this.grouping = data;
    },
    downloadAnalytics() {
      let cfType = this.cashFlowType(this.link)
      this.$http({url: '/export/analytics', method: 'POST', data: [this.analytics, this.activeReportDates, this.activeGroupName, cfType], responseType: 'blob'})
      .then(response => {
        const blob = new Blob([response.data], {type: response.data.type});
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob)
        link.download = "export_analytics.xlsx";
        link.click();

        console.log('Report->downloadAnalytics(): done')
      })
      .catch(error => console.error(`Report->downloadAnalytics(): ERROR: ${error}`))
    },
    cashFlowType(link){
      if (link.includes('direct-fact') || link.includes('reinsurance-fact')) {
        return 'fact'
      } else if (link.includes('direct-expected') || link.includes('reinsurance-expected')){
        return 'expected'
      } else {
        return 'portfolio'
      }
    }    
  },
}
</script>

<style scoped>
.data-block{
  width: fit-content;
	display: flex;
	flex-direction: column;
	gap: 20px;
  box-shadow: 5px 5px 5px #e0e0e0;
	border: 1px solid #c0c0c0;
	padding: 20px;
  background-color: white;
  min-width: 500px;
}

.data-block-top{
  display: flex;
  justify-content: space-between;
}

.top-right-item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
}

.top-right-item:first-child {
  border-left: none;
}

.top-right-item > a {
  padding-left: 0.5rem;
  cursor: pointer;
  color: #3ebaff;
}

.loading{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading img{
  width: 3rem;
}

</style>
	